import TemplateView from '../../../../TemplateView'
import UsersCountInput from './UsersCountInput'
import messageResource from '../../../../messageResource'
import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {getDiscount, getPrice, getPricePerTimeInterval, getPurchasePeriod, getUsersCount, isSelectUnlimitedUsers} from './selectors'
import {setPurchasePeriod, setUsersCountAndUnlimitedFlag} from './actions'
import {MONTH_LICENSES_DURATION, PricingModelType, UNLIMITED_USERS_COUNT, USERS_LIMITED_PACKAGES, YEAR_LICENSES_DURATION} from '../../constants'
import {getMaxUsersToUnlimited, getPricingModelType, getUsersLowerLimit} from '../../selectors'
import NumberFormatter from '../../../../number_formatter'
import SimpleListMenuButton from '../../../../SimpleListMenuButton'

class PurchaseChooserCard extends TemplateView {
    constructor({
        setPurchasePeriod = () => {},
        setUsersCountAndUnlimitedFlag = () => {},
        onPurchaseButtonClick = () => {},
    }) {
        super()

        this.state = {
            pricingModelType: PricingModelType.USER,
            price: 0,
            pricePerTimeInterval: 0,
            discount: 0,
            purchasePeriod: 1,
            maxUsersToUnlimited: 0,
            currentUsersCountSelected: 0,
            isSelectUnlimitedUsers: false,
            usersLowerLimit: 0,
        }

        this.actions = {
            setPurchasePeriod,
            setUsersCountAndUnlimitedFlag,
        }

        this.callbacks = {
            onPurchaseButtonClick,
        }

        this.onAnyStatePropertyChanged(['maxUsersToUnlimited', 'currentUsersCountSelected', 'isSelectUnlimitedUsers'], () => {
            this.usersCountInput.setState({
                maxUsersToUnlimited: this.state.maxUsersToUnlimited,
                currentUsersCountSelected: this.state.currentUsersCountSelected,
                isSelectUnlimitedUsers: this.state.isSelectUnlimitedUsers
            })

            const packageKey = this.state.isSelectUnlimitedUsers ? UNLIMITED_USERS_COUNT : this.state.currentUsersCountSelected
            this.usersCountByPackage.setSelectedItem(this.usersCountByPackageItems[packageKey])
        })

        this.onStatePropertyChanged('isSelectUnlimitedUsers', (unlimitedSelected) => {
            this.$noteUnlimitedQuestion.toggle(!unlimitedSelected)
            this.$noteUnlimited.toggle(unlimitedSelected)
        })

        this.onStatePropertyChanged('price', (price) => {
            this.$price.text(messageResource.getMessage('licenses.chooser.price', [this._getFormattedPrice(price)]))
        })

        this.onAnyStatePropertyChanged(['pricePerTimeInterval', 'isSelectUnlimitedUsers'], () => {
            if (this.state.isSelectUnlimitedUsers) {
                this.state.purchasePeriod === MONTH_LICENSES_DURATION
                ? this.$pricePerMonthInterval.text(messageResource.getMessage('licenses.chooser.price_unlimited_month', [this.state.maxUsersToUnlimited]))
                : this.$pricePerMonthInterval.text(messageResource.getMessage('licenses.chooser.price_unlimited_year', [this.state.maxUsersToUnlimited]))
            } else {
                this.$pricePerMonthInterval.text(messageResource.getMessage('licenses.chooser.price_per_month', [
                    this._getFormattedPrice(this.state.pricePerTimeInterval / this.state.purchasePeriod)
                ]))
            }
        })

        this.onStatePropertyChanged('purchasePeriod', (purchasePeriod) => {
            this.$monthlyPeriod.toggleClass('active', purchasePeriod === MONTH_LICENSES_DURATION)
            this.$annualPeriod.toggleClass('active', purchasePeriod === YEAR_LICENSES_DURATION)
        })

        this.onStatePropertyChanged('discount', (discount) => {
            this.$discount.toggle(discount !== 0)
            this.$discountText.text(messageResource.getMessage('licenses.chooser.save_percent', [discount]))
        })

        this.onStatePropertyChanged('usersLowerLimit', (usersLowerLimit) => {
            this.usersCountInput.setState({usersLowerLimit})
        })

        this.onStatePropertyChanged('pricingModelType', (pricingModelType) => {
            this.usersCountInput.toggle(pricingModelType === PricingModelType.USER)
            this.usersCountByPackage.toggle(pricingModelType === PricingModelType.PACKAGE)
        })
    }

    templateHtml() {
        return '<div class="container">' +
               '    <div class="title"><%=title%></div>' +
               '    <div class="licensesPeriod">' +
               '        <div class="monthlyPeriod"><span><%=monthlyPeriod%></span></div>' +
               '        <div class="annualPeriod"><span><%=annualPeriod%></span></div>' +
               '    </div>' +
               '    <div class="discount">' +
               '        <div class="text"></div>' +
               '        <div class="img"></div>' +
               '    </div>' +
               '    <div class="userCounts">' +
               '        <div class="usersInputsTitle"><span><%=usersInputsTitle%></span></div>' +
               '        <div class="usersInputs">' +
               '            <div class="usersCountByPackage"/>' +
               '        </div>' +
               '        <div class="noteUnlimited">' +
               '            <span class="unlimitedQuestion"><%=noteUnlimitedQuestion%></span>' +
               '            <span class="unlimited"><%=noteUnlimited%></span>' +
               '        </div>' +
               '    </div>' +
               '    <div class="pricing">' +
               '        <div class="price"/>' +
               '        <div class="pricePerMonth"/>' +
               '    </div>' +
               '    <div class="purchaseButton"><span><%=purchaseButtonText%></span></div>' +
               '</div>'
    }

    messageKeys() {
        return {
            monthlyPeriod: 'licenses.chooser.monthly',
            annualPeriod: 'licenses.chooser.annual',
            noteUnlimitedQuestion: 'licenses.chooser.unlimited_users_question',
            noteUnlimited: 'licenses.unlimited_users',
            usersInputsTitle: 'licenses.chooser.card_users_number',
            purchaseButtonText: 'licenses.chooser.button_purchase_text',
            title: 'licenses.chooser.card_purchase_title',
        }
    }

    afterRender() {
        this.usersCountInput = new UsersCountInput({
            setUsersCountAndUnlimitedFlag: this.actions.setUsersCountAndUnlimitedFlag
        }).init(this.find('.usersInputs'))

        this.usersCountByPackage = new SimpleListMenuButton({
            itemHtmlCallback: item => item.title,
            onSelect: item => {
                if (item.value > 0) {
                    this.actions.setUsersCountAndUnlimitedFlag(false, item.value)
                } else {
                    this.actions.setUsersCountAndUnlimitedFlag(true, this.state.maxUsersToUnlimited)
                }
            },
            itemHeight: 30,
        }).init(this.find('.usersCountByPackage'))

        this.usersCountByPackageItems = {}
        USERS_LIMITED_PACKAGES.forEach(p => {
            this.usersCountByPackageItems[p] = {
                title: p,
                value: p
            }
        })
        this.usersCountByPackageItems[UNLIMITED_USERS_COUNT] = {
            title: messageResource.getMessage('licenses.unlimited'),
            value: UNLIMITED_USERS_COUNT
        }
        this.usersCountByPackage.setItems(Object.values(this.usersCountByPackageItems))

        this.$price = this.find('.price')
        this.$pricePerMonthInterval = this.find('.pricePerMonth')

        this.$monthlyPeriod = this.find('.monthlyPeriod')
        this.$annualPeriod = this.find('.annualPeriod')

        this.$monthlyPeriod.click(() => this.actions.setPurchasePeriod(MONTH_LICENSES_DURATION))
        this.$annualPeriod.click(() => this.actions.setPurchasePeriod(YEAR_LICENSES_DURATION))

        this.$noteUnlimitedQuestion = this.find('.noteUnlimited .unlimitedQuestion')
        this.$noteUnlimited = this.find('.noteUnlimited .unlimited')

        this.$noteUnlimitedQuestion.click(() => {
            this.actions.setUsersCountAndUnlimitedFlag(true, this.state.maxUsersToUnlimited + 1)
        })

        this.$discount = this.find('.discount')
        this.$discountText = this.find('.discount .text')
        this.find('.purchaseButton').click(this.callbacks.onPurchaseButtonClick)

        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)
    }

    _getFormattedPrice(priceInCents) {
        return this.numberFormatter.format(priceInCents / 100)
    }
}

export default connect(
    (state) => ({
        pricingModelType: getPricingModelType(state),
        price: getPrice(state),
        pricePerTimeInterval: getPricePerTimeInterval(state),
        discount: getDiscount(state),
        purchasePeriod: getPurchasePeriod(state),
        maxUsersToUnlimited: getMaxUsersToUnlimited(state),
        currentUsersCountSelected: getUsersCount(state),
        isSelectUnlimitedUsers: isSelectUnlimitedUsers(state),
        usersLowerLimit: getUsersLowerLimit(state),
    }),
    (dispatch) => ({
        setPurchasePeriod: bindActionCreators(setPurchasePeriod, dispatch),
        setUsersCountAndUnlimitedFlag: bindActionCreators(setUsersCountAndUnlimitedFlag, dispatch),
    })
)(PurchaseChooserCard)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/PurchaseChooserCard.js